/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropcontingent1Inputs */

const en_dropcontingent1 = /** @type {(inputs: Dropcontingent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contingent (prizes in total)`)
};

const de_dropcontingent1 = /** @type {(inputs: Dropcontingent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontingent (Preise insgesamt)`)
};

/**
* | output |
* | --- |
* | "Contingent (prizes in total)" |
*
* @param {Dropcontingent1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropcontingent1 = /** @type {((inputs?: Dropcontingent1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropcontingent1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropcontingent1(inputs)
	return de_dropcontingent1(inputs)
});
export { dropcontingent1 as "dropContingent" }